import api from '../services/api';

export const backupConfigAPI = {
  create: async (uniqueId, data) => {
    const response = await api.post(`/installation/${uniqueId}/backup-config`, data);
    return response.data;
  },

  getByInstallation: async (uniqueId) => {
    const response = await api.get(`/installation/${uniqueId}/backup-configs`);
    return response.data;
  },

  getAll: async (page = 1, limit = 10) => {
    const response = await api.get('/backup-configs', {
      params: { page, limit }
    });
    return response.data;
  },

  update: async (configId, data) => {
    const response = await api.put(`/backup-config/${configId}`, data);
    return response.data;
  },

  delete: async (configId) => {
    const response = await api.delete(`/backup-config/${configId}`);
    return response.data;
  },

  updateStatus: async (configId, status) => {
    const response = await api.post(`/backup-config/${configId}/status`, { status });
    return response.data;
  }
};